<div [class]="SideBorderClass" [style]="CustomStyleCard">
  <div [class]="IconPositionClass">
    @for (icon of Icons; track $index){
    <img class="icon-atendimento" [src]="'icons/' + icon" alt="Ícone complementar ao título" />
    }
  </div>
  <div class="col-11" [style]="CustomStyleBody">
    @if (Topic) {
    <p class="topic-atendimento-size" style="font-weight: 600;">{{Topic}}</p>
    }
    <h5 [innerHtml]="Title | safeHtml" class="title-atendimento-size" style="font-weight: bold;" [class]="EmphasisStyle">
    </h5>
    <div class="description-atendimento-size" style="white-space: pre-wrap;">
      <ng-content></ng-content>
    </div>
  </div>
</div>
